import classNames from "classnames";
import { CSSProperties } from "react";
import styles from "./Page.module.css";

export interface PageProps {
  flexDirection?: string;
  contentOrientation?: string;
  mobile?: boolean;
  forHero?: boolean,
  className?: string;
  children: React.ReactNode;
  style?: {};
}

export const Page = ({
  flexDirection = "unset",
  contentOrientation = "unset",
  mobile,
  forHero,
  children,
  className = "",
  ...props }: PageProps) => {
  return (
    <div className={classNames(styles.page,
      className,
      forHero && 'forHero',
      { mobile: mobile })}
      id={forHero ? '' : 'page'}
      style={{ justifyContent: contentOrientation, flexDirection: flexDirection } as CSSProperties}
      {...props}
    >
      {children}
    </div>
  );
};
